import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Search, Bot, Sparkles } from 'lucide-react';
import TechnicalAuditPage from '@/pages/TechnicalAuditPage';
import GeoAuditPage from '@/pages/GeoAuditPage';
import AIVisibilityPage from '@/pages/AIVisibilityPage';

const VALID_TABS = ['seo', 'geo', 'ai'];
const DEFAULT_TAB = 'seo';

export default function AuditSitePage() {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParam = searchParams.get('tab');
  const activeTab = VALID_TABS.includes(tabParam) ? tabParam : DEFAULT_TAB;

  const handleTabChange = (value) => {
    setSearchParams({ tab: value }, { replace: true });
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-heading font-bold">Audit Site</h1>
        <p className="text-muted-foreground mt-1">
          Audit SEO tehnic, GEO (AI Readiness) și Vizibilitate AI, într-un singur loc
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={handleTabChange} className="w-full">
        <TabsList className="grid w-full grid-cols-3 bg-secondary">
          <TabsTrigger value="seo" className="flex items-center gap-2">
            <Search className="w-4 h-4" />
            Audit SEO
          </TabsTrigger>
          <TabsTrigger value="geo" className="flex items-center gap-2">
            <Bot className="w-4 h-4" />
            Audit GEO
          </TabsTrigger>
          <TabsTrigger value="ai" className="flex items-center gap-2">
            <Sparkles className="w-4 h-4" />
            Vizibilitate AI
          </TabsTrigger>
        </TabsList>

        <TabsContent value="seo" className="mt-6">
          <TechnicalAuditPage />
        </TabsContent>
        <TabsContent value="geo" className="mt-6">
          <GeoAuditPage />
        </TabsContent>
        <TabsContent value="ai" className="mt-6">
          <AIVisibilityPage />
        </TabsContent>
      </Tabs>
    </div>
  );
}
